import React, { useEffect, useRef } from 'react';
import css from './Sections.module.css';

/**
 * SectionEmailSignup
 * ------------------
 * Renders a Kit (ConvertKit) inline email signup form above the footer
 * on the landing page. The Kit script is loaded once on mount and
 * injects the hosted form into the data-uid placeholder div.
 *
 * Kit form ID: 3c99df7225
 * Managed at: https://app.kit.com
 */
function SectionEmailSignup() {
  const containerRef = useRef(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (!containerRef.current || scriptLoadedRef.current) return;
    scriptLoadedRef.current = true;

    // Kit's script looks for <script data-uid="..."> tags and replaces
    // them in-place with the rendered form. By appending the script
    // inside our container, the form renders exactly where we want it.
    const script = document.createElement('script');
    script.src = 'https://libroloop.kit.com/3c99df7225/index.js';
    script.async = true;
    script.setAttribute('data-uid', '3c99df7225');
    containerRef.current.appendChild(script);
  }, []);

  return (
    <div className={css.emailSignupSection}>
      <div className={css.emailSignupContainer} ref={containerRef} />
    </div>
  );
}

export default SectionEmailSignup;
